import * as swcHelpers from '@swc/helpers';
import { areColumnsValid, areColumnCheckboxesValid, isDeliveryIntervalValid, isConfiguratorValid, splitTotalQuantityBetweenEyesides, isColumnValid, isQuantityValid } from './utils/state-helpers.js';

const reducer = (state, action)=>{
    switch(action.type){
        case 'setPurchaseType':
            {
                const { purchaseType  } = action.payload;
                return swcHelpers.objectSpread({}, state, {
                    configurations: swcHelpers.objectSpread({}, state.configurations, {
                        purchaseType
                    })
                });
            }
        case 'setDeliveryInterval':
            {
                const { deliveryInterval  } = action.payload;
                return swcHelpers.objectSpread({}, state, {
                    configurations: swcHelpers.objectSpread({}, state.configurations, {
                        subscriptionPurchaseConfigurations: swcHelpers.objectSpread({}, state.configurations.subscriptionPurchaseConfigurations, {
                            deliveryInterval
                        })
                    }),
                    configurator: swcHelpers.objectSpread({}, state.configurator, {
                        deliveryInterval: {
                            isValid: true,
                            showError: false
                        }
                    })
                });
            }
        case 'setColumnCheckbox':
            {
                const { eyeSide , isEnabled  } = action.payload;
                const newColumnUIState = swcHelpers.objectSpread({}, state.configurator[eyeSide], {
                    isEnabled
                });
                const isColumnValid$1 = isColumnValid(newColumnUIState, state.configurations[eyeSide]);
                const newState = swcHelpers.objectSpread({}, state, {
                    configurator: swcHelpers.objectSpread({}, state.configurator, {
                        [eyeSide]: swcHelpers.objectSpread({}, newColumnUIState, {
                            isValid: isColumnValid$1
                        })
                    })
                });
                return swcHelpers.objectSpread({}, newState, {
                    configurator: swcHelpers.objectSpread({}, newState.configurator, {
                        columns: swcHelpers.objectSpread({}, newState.configurator.columns, {
                            areValid: areColumnsValid(newState)
                        }),
                        columnCheckboxes: swcHelpers.objectSpread({}, newState.configurator.columnCheckboxes, {
                            areValid: areColumnCheckboxesValid(newState),
                            showError: false
                        })
                    })
                });
            }
        case 'setPrescriptionAttribute':
            {
                const { eyeSide , attribute , value  } = action.payload;
                const previousColumnUIState = state.configurator[eyeSide];
                const newColumnConfiguration = swcHelpers.objectSpread({}, state.configurations[eyeSide], {
                    prescription: swcHelpers.objectSpread({}, state.configurations[eyeSide].prescription, {
                        [attribute]: value
                    })
                });
                const newColumnUIState = swcHelpers.objectSpread({}, previousColumnUIState, {
                    isValid: isColumnValid(previousColumnUIState, newColumnConfiguration)
                });
                const newState = swcHelpers.objectSpread({}, state, {
                    configurations: swcHelpers.objectSpread({}, state.configurations, {
                        [eyeSide]: newColumnConfiguration
                    }),
                    configurator: swcHelpers.objectSpread({}, state.configurator, {
                        [eyeSide]: newColumnUIState
                    })
                });
                return swcHelpers.objectSpread({}, newState, {
                    configurator: swcHelpers.objectSpread({}, newState.configurator, {
                        columns: swcHelpers.objectSpread({}, newState.configurator.columns, {
                            areValid: areColumnsValid(newState)
                        })
                    })
                });
            }
        case 'setRxToggleSelection':
            {
                const { rxToggle  } = action.payload;
                return swcHelpers.objectSpread({}, state, {
                    configurations: swcHelpers.objectSpread({}, state.configurations, {
                        rxToggle
                    })
                });
            }
        case 'setSelectedQuantity':
            {
                const { eyeSide , quantity  } = action.payload;
                return swcHelpers.objectSpread({}, state, {
                    configurations: swcHelpers.objectSpread({}, state.configurations, {
                        [eyeSide]: swcHelpers.objectSpread({}, state.configurations[eyeSide], {
                            quantity
                        })
                    })
                });
            }
        case 'setTotalQuantity':
            {
                const { totalQuantity  } = action.payload;
                const { bothQuantity , leftQuantity , rightQuantity  } = splitTotalQuantityBetweenEyesides(state, totalQuantity);
                return swcHelpers.objectSpread({}, state, {
                    configurations: swcHelpers.objectSpread({}, state.configurations, {
                        left: swcHelpers.objectSpread({}, state.configurations.left, {
                            quantity: leftQuantity
                        }),
                        right: swcHelpers.objectSpread({}, state.configurations.right, {
                            quantity: rightQuantity
                        }),
                        both: swcHelpers.objectSpread({}, state.configurations.both, {
                            quantity: bothQuantity
                        })
                    })
                });
            }
        case 'resetTotalQuantity':
            {
                const isBothEnabled = state.configurator.both.isEnabled;
                const isLeftEnabled = state.configurator.left.isEnabled;
                const isRightEnabled = state.configurator.right.isEnabled;
                const leftQuantity = isLeftEnabled ? 1 : state.configurations.left.quantity;
                const rightQuantity = isRightEnabled ? 1 : state.configurations.right.quantity;
                const bothQuantity = isBothEnabled ? 1 : state.configurations.both.quantity;
                return swcHelpers.objectSpread({}, state, {
                    configurations: swcHelpers.objectSpread({}, state.configurations, {
                        left: swcHelpers.objectSpread({}, state.configurations.left, {
                            quantity: leftQuantity
                        }),
                        right: swcHelpers.objectSpread({}, state.configurations.right, {
                            quantity: rightQuantity
                        }),
                        both: swcHelpers.objectSpread({}, state.configurations.both, {
                            quantity: bothQuantity
                        })
                    })
                });
            }
        case 'updateIsConfiguratorValid':
            {
                const isConfiguratorValid$1 = isConfiguratorValid(state);
                return swcHelpers.objectSpread({}, state, {
                    configurator: swcHelpers.objectSpread({}, state.configurator, {
                        isConfiguratorValid: isConfiguratorValid$1
                    })
                });
            }
        case 'resetFetchedSku':
            {
                const { eyeSide  } = action.payload;
                return swcHelpers.objectSpread({}, state, {
                    queries: swcHelpers.objectSpread({}, state.queries, {
                        [eyeSide]: swcHelpers.objectSpread({}, state.queries[eyeSide], {
                            sku: undefined,
                            error: undefined
                        })
                    })
                });
            }
        case 'updateFetchedSku':
            {
                const { eyeSide , sku  } = action.payload;
                return swcHelpers.objectSpread({}, state, {
                    queries: swcHelpers.objectSpread({}, state.queries, {
                        [eyeSide]: swcHelpers.objectSpread({}, state.queries[eyeSide], {
                            sku
                        })
                    })
                });
            }
        case 'updateStockStatus':
            {
                const { eyeSide , stockIndicatorStatus  } = action.payload;
                return swcHelpers.objectSpread({}, state, {
                    configurator: swcHelpers.objectSpread({}, state.configurator, {
                        [eyeSide]: swcHelpers.objectSpread({}, state.configurator[eyeSide], {
                            stockIndicatorStatus
                        })
                    })
                });
            }
        case 'updateMaxSelectableQuantity':
            {
                const { eyeSide , maxSelectableQuantity  } = action.payload;
                const { quantity  } = state.configurations[eyeSide];
                const { selectionInvalidatedCount  } = state.configurator[eyeSide].quantitySelector;
                const isQuantityValid$1 = isQuantityValid(quantity, maxSelectableQuantity);
                const productIsOutOfStock = maxSelectableQuantity === 0;
                let newQuantitySelection = quantity;
                let newSelectionInvalidatedCount = selectionInvalidatedCount;
                if (!isQuantityValid$1 && !productIsOutOfStock) {
                    // If the updated max selectable quantity is greater than 0 and less than the configured quantity
                    // reset the configured quantity to the new max, and update the 'selection invalidated' count
                    newQuantitySelection = maxSelectableQuantity;
                    newSelectionInvalidatedCount = (selectionInvalidatedCount || 0) + 1;
                }
                return swcHelpers.objectSpread({}, state, {
                    configurations: swcHelpers.objectSpread({}, state.configurations, {
                        [eyeSide]: swcHelpers.objectSpread({}, state.configurations[eyeSide], {
                            quantity: newQuantitySelection
                        })
                    }),
                    configurator: swcHelpers.objectSpread({}, state.configurator, {
                        [eyeSide]: swcHelpers.objectSpread({}, state.configurator[eyeSide], {
                            quantitySelector: swcHelpers.objectSpread({}, state.configurator[eyeSide].quantitySelector, {
                                maxSelectableQuantity,
                                selectionInvalidatedCount: newSelectionInvalidatedCount
                            })
                        })
                    })
                });
            }
        case 'updateAllValidations':
            {
                const areColumnsValid$1 = areColumnsValid(state);
                const areColumnCheckboxesValid$1 = areColumnCheckboxesValid(state);
                const isDeliveryIntervalValid$1 = isDeliveryIntervalValid(state);
                const isInvalid = [
                    areColumnsValid$1,
                    areColumnCheckboxesValid$1,
                    isDeliveryIntervalValid$1
                ].some((value)=>value === false
                );
                return swcHelpers.objectSpread({}, state, {
                    configurator: swcHelpers.objectSpread({}, state.configurator, {
                        isConfiguratorValid: !isInvalid,
                        columns: swcHelpers.objectSpread({}, state.configurator.columns, {
                            areValid: areColumnsValid$1
                        }),
                        columnCheckboxes: swcHelpers.objectSpread({}, state.configurator.columnCheckboxes, {
                            areValid: areColumnCheckboxesValid$1
                        }),
                        deliveryInterval: swcHelpers.objectSpread({}, state.configurator.deliveryInterval, {
                            isValid: isDeliveryIntervalValid$1
                        })
                    })
                });
            }
        case 'triggerErrors':
            {
                const { isConfiguratorValid , invalidSubmissionsCount: previousCount , columns , columnCheckboxes , deliveryInterval ,  } = state.configurator;
                const newCount = (previousCount || 0) + 1;
                if (isConfiguratorValid) {
                    return state;
                }
                return swcHelpers.objectSpread({}, state, {
                    configurator: swcHelpers.objectSpread({}, state.configurator, {
                        invalidSubmissionsCount: newCount,
                        columns: swcHelpers.objectSpread({}, columns, {
                            showError: !columns.areValid
                        }),
                        columnCheckboxes: swcHelpers.objectSpread({}, columnCheckboxes, {
                            showError: !columnCheckboxes.areValid
                        }),
                        deliveryInterval: swcHelpers.objectSpread({}, deliveryInterval, {
                            showError: (deliveryInterval === null || deliveryInterval === void 0 ? void 0 : deliveryInterval.isValid) === false
                        })
                    })
                });
            }
        case 'resetErrors':
            {
                return swcHelpers.objectSpread({}, state, {
                    configurator: swcHelpers.objectSpread({}, state.configurator, {
                        invalidSubmissionsCount: undefined,
                        columns: swcHelpers.objectSpread({}, state.configurator.columns, {
                            showError: false
                        }),
                        columnCheckboxes: swcHelpers.objectSpread({}, state.configurator.columnCheckboxes, {
                            showError: false
                        }),
                        deliveryInterval: swcHelpers.objectSpread({}, state.configurator.deliveryInterval, {
                            showError: false
                        })
                    })
                });
            }
        case 'updateQueryError':
            {
                const { eyeSide , error  } = action.payload;
                return swcHelpers.objectSpread({}, state, {
                    queries: swcHelpers.objectSpread({}, state.queries, {
                        [eyeSide]: swcHelpers.objectSpread({}, state.queries[eyeSide], {
                            error
                        })
                    })
                });
            }
        case 'setQueryLoading':
            {
                const { eyeSide , loading  } = action.payload;
                return swcHelpers.objectSpread({}, state, {
                    queries: swcHelpers.objectSpread({}, state.queries, {
                        [eyeSide]: swcHelpers.objectSpread({}, state.queries[eyeSide], {
                            loading
                        })
                    })
                });
            }
        default:
            return state;
    }
};

export { reducer };
//# sourceMappingURL=reducer.js.map
